import axiosClient from '../../../config/api/axios.js'
import { titleFromMessages } from './aetherMessageHelpers.js'

const SESSION_MAP_KEY = 'sia.aether.backendSessions.v1'
const pendingSessionPromises = new Map()

function safeJsonParse(value, fallback) {
  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

export function readSessionMap() {
  if (typeof window === 'undefined') return {}
  return safeJsonParse(window.localStorage.getItem(SESSION_MAP_KEY), {}) || {}
}

export function writeSessionMap(map) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(SESSION_MAP_KEY, JSON.stringify(map))
  } catch {
    /* ignore storage failures */
  }
}

async function createBackendSession(messages, signal) {
  const { data } = await axiosClient.post(
    '/api/sessions',
    { title: titleFromMessages(messages) },
    { signal },
  )
  return data.id
}

export async function ensureBackendSession(threadId, messages, signal) {
  const map = readSessionMap()
  if (map[threadId]) return map[threadId]
  if (pendingSessionPromises.has(threadId)) return pendingSessionPromises.get(threadId)

  const promise = createBackendSession(messages, signal)
    .then((sessionId) => {
      const latestMap = readSessionMap()
      writeSessionMap({ ...latestMap, [threadId]: sessionId })
      return sessionId
    })
    .finally(() => {
      pendingSessionPromises.delete(threadId)
    })
  pendingSessionPromises.set(threadId, promise)
  return promise
}
